import { Button, useTheme } from "@mui/material";
import { ChevronDown, ChevronUp } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	expanded: boolean;
	onClick: () => void;
	collapsedLabel?: string;
	expandedLabel?: string;
};

export const ShowAllToggleButton: FC<Props> = ({
	expanded,
	onClick,
	collapsedLabel,
	expandedLabel,
}) => {
	const theme = useTheme();
	const { t } = useResource();

	const Chevron = expanded ? ChevronUp : ChevronDown;
	const label = expanded
		? (expandedLabel ?? t(Resources.Common.Hide))
		: (collapsedLabel ?? t(Resources.Common.DisplayAll));

	return (
		<Button
			variant="showAll"
			onClick={onClick}
			aria-expanded={expanded}
			endIcon={<Chevron size={theme.iconSize.sm} />}
		>
			{label}
		</Button>
	);
};
